"use client";
import Reveal from "../../components/Reveal"
import { motion } from 'framer-motion';
import { useTranslations } from "next-intl";

export default function LifetimeSection() {
    const t = useTranslations('invester');
    return (
        <section className="flex max-lg:flex-col justify-between items-center max-w-[1440px] mx-auto py-[120px] max-lg:py-20 max-sm:py-14 px-[78px] max-lg:px-4">
            <div className="max-w-[512px] max-lg:text-center">
                <Reveal
                    delay={0.1}
                    duration={0.8}
                    direction="left"
                    withBlur={true}
                    blurAmount={8}
                >
                    <h2 className="text-[48px]/[56px] max-lg:text-[32px]/[40px] tracking-[-1px] max-lg:max-w-[300px] max-lg:mx-auto">{t('your-once-in-a')} <span className="text-[#06f]">{t('lifetime-investment')}</span></h2>
                </Reveal>
                <Reveal
                    delay={0.5}
                    duration={0.8}
                    direction="left"
                    withBlur={true}
                    blurAmount={8}
                >
                    <p className="text-base text-[#646464] font-light mt-6">{t('our-vision-is-to-reshape-how-the-world-powers-artificial-intelligence-transforming-billions-of-devices-into-a-distributed-democratized-ai-network')}</p>
                </Reveal>
            </div>
            <div className="w-1/2 max-lg:w-full max-lg:h-auto p-6 max-lg:p-0 max-lg:mt-14 max-lg:grid grid-cols-2 max-sm:grid-cols-1 gap-2">
                <motion.div
                    initial={{ opacity: 0, translateX: 40 }}
                    whileInView={{ opacity: 1, translateX: 0 }}
                    transition={{ duration: 1, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className="max-lg:h-full"
                >
                    <div className="h-full bg-[url('/images/backgrounds/lifetime1.png')] bg-cover bg-center p-8 flex max-lg:flex-col justify-between items-center rounded-[24px] border-[2px] border-[#E9F3FF]">
                        <p className="text-[56px]/[64px]">2.8M+</p>
                        <div>
                            <p className="text-lg text-[#06f] text-end max-lg:text-center mb-3">{t('devices')}</p>
                            {/* <p className="text-[#646464] text-sm">{t('as-of-august-2025')}</p> */}
                            <p className="text-[#646464] text-sm">September 2025</p>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, translateX: 40 }}
                    whileInView={{ opacity: 1, translateX: 0 }}
                    transition={{ delay: 0.3, duration: 1, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className="max-lg:h-full"
                >
                    <div className="h-full bg-[url('/images/backgrounds/lifetime.png')] bg-cover bg-center p-8 flex max-lg:flex-col justify-between items-center rounded-[24px] border-[2px] border-[#E9F3FF] mt-8 max-lg:mt-0">
                        <p className="text-[56px]/[64px]">144M+</p>
                        <div>
                            <p className="text-lg text-[#06f] text-end max-lg:text-center mb-3">{t('devices')}</p>
                            <p className="text-[#646464] text-sm">September 2030</p>
                        </div>
                    </div>
                </motion.div>

            </div>
        </section>
    )
}
